<template>
  <div>
    <b-table
      small
      sticky-header
      hover
      aria-busy="true"
      class="tabelaPadrao"
      :per-page="qtdRegistrosPorPagina"
      :fields="colunas"
      :items="dados"
      :busy="tabelaCarregando"
      :tbody-tr-class="rowClass ? rowClass : this.defaultRowClass"
      :current-page="lazy ? 1 : paginaAtual"
      @row-clicked="rowClicked">

      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>{{ $t("msg.carregando") }}...</strong>
        </div>
      </template>

      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(selected)="row">
        <div>
          <b-form-checkbox size="sm" v-model="row.item.selected">
          </b-form-checkbox>
        </div>
      </template>

      <template v-slot:cell(actions)="row" v-if="!isPopup">
				<b-link @click="confirmaExclusao(row.item, label)">
					<div class="icoBtn icoBtnVm" :id="row.index+'-excluir'">
						<b-icon-x-circle-fill></b-icon-x-circle-fill>
					</div>
				</b-link>
			</template>
    </b-table>
  


    <b-container>
      <b-row>
        <b-col>
          {{ "Total de Registros: " + totalRegistros }}
        </b-col>
        <b-col v-if="paginado">
          <b-pagination
            size="md"
            v-model="paginaAtual"
            :total-rows="totalRegistros"
            :per-page="qtdRegistrosPorPagina"
            @input="mudaPagina"
            align="right"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-container>
  </div>

</template>

<script>
import { EventBus } from "@/EventBus";
import VueI18n from 'vue-i18n'

export default {
  /**
   * Os props são os seguintes:
   * colunas: O objeto com os nome e catacteristicas das colunas
   * dados: O objeto dedados que irá carregar os itens do grid
   * flagCarregando: identifica quando é pra colocar o icone de carregando
   * totalRegistros: variavel com a quantidade de registros retornados
   */
  props: {
    colunas: {},
    dados: {},
    rowClick: { type: Function },
    totalRegistros: {},
    textField: {},
    paginado: { type: Boolean, default: true },
    lazy: { type: Boolean, default: true },
    qtdRegistrosPorPagina: {
      type: Number,
      default: window.app.qtdRegistrosPorPagina,
    },
    rowClass: { type: Function },
    abreCarregado: { type: Boolean, default: true },
    selecionavel: { type: Boolean, default: false },
    label: { type: String, default: 'descricao' }
  },

  created() {
    if (this.abreCarregado && this.lazy) {
      this.tabelaCarregando = true;
      this.pesquisarDadosGrid().then(() => {
        this.tabelaCarregando = false;
      });
    }
  },

  data() {
    return {
      tabelaCarregando: false,
      selecao: [],
      paginaAtual: 1,
      isPopup: window.app.isPopup,
      pesquisarDadosGrid: window.app.pesquisarDadosGrid,
      confirmaExclusao: window.app.confirmaExclusao,
      infoModal: { id: 'info-modal', title: '', content: '' },
    };
  },

  mounted() {
    EventBus.$on("reset-pagina", (clickCount) => {
      this.paginaAtual = 1;
      this.mudaPagina();
    });
  },

  methods: {
  
    rowClicked(e) {
      if (this.rowClick) {
        EventBus.$emit("LOADING");
        this.rowClick(e);
      }
    },

    defaultRowClass(item, type) {
      if (!item || type !== "row") return;
      if (typeof item.status != "undefined" && !item.status)
        return "table-inactive";
    },

    mudaPagina() {
      if (this.lazy && this.abreCarregado)
        this.pesquisarDadosGrid(this.paginaAtual - 1).then(() => {
          this.tabelaCarregando = false;
        });
    },
  },
};
</script>